module Shared.Dto.Scab

let scabInfectionPercentageToString (percentage: float) : string =
    if percentage < 100. then "Keine Infektion"
    else if percentage < 134. then "Leichte Infektion"
    else if percentage < 202. then "Mittlere Infektion"
    else "Schwere Infektion"